import { RequestExplorerActionTypes, RequestExplorerContext } from 'contexts/RequestExplorer';
import type { FC } from 'react';
import { useContext } from 'react';
import { EditGrid } from '../../../EditGrid';

type RequestHeadersProps = {
  locked?: boolean;
};

const RequestHeaders: FC<RequestHeadersProps> = ({ locked }) => {
  const ctx = useContext(RequestExplorerContext);
  if (!ctx) {
    // eslint-disable-next-line no-console
    console.error('RequestExplorerContextProvider required');

    return <>RequestExplorerContextProvider required</>;
  }

  return (
    <EditGrid
      columns={{
        key: {
          key: 'key',
          label: 'Key',
          placeholder: 'Key',
          width: '10fr'
        },
        value: {
          key: 'value',
          label: 'Value',
          placeholder: 'Value',
          width: '20fr'
        }
      }}
      value={ctx.state.headers}
      checked="use"
      onToggleChecked={(index, checked) => {
        ctx?.dispatch({
          type: RequestExplorerActionTypes.TOGGLE_HEADER,
          payload: { index, active: checked }
        });
      }}
      onChange={(index, column, value) => {
        const payload = {
          index,
          key: undefined,
          value: undefined
        };
        payload[column] = value;
        ctx?.dispatch({
          type: RequestExplorerActionTypes.UPDATE_HEADER,
          payload
        });
      }}
      onDeleteRow={index => {
        ctx?.dispatch({
          type: RequestExplorerActionTypes.DELETE_HEADER,
          payload: { index }
        });
      }}
    />
  );
};
export default RequestHeaders;
